// https://usehooks.com/useOnScreen/
import { useEffect, useState } from "react"

function useOnScreen(ref, rootMargin = "0px") {
  // State and setter for storing whether element is visible
  const [isIntersecting, setIntersecting] = useState(false)

  useEffect(() => {
    const node = ref.current
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Update our state when observer callback fires
        setIntersecting(entry.isIntersecting)
      },
      {
        rootMargin
      }
    )
    if (node) {
      observer.observe(node)
    }
    return () => {
      observer.unobserve(node)
    }
  }, [ref, rootMargin])

  return isIntersecting
}

export default useOnScreen
